import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Tabs, TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SidebarAndContainer from '../../components/sidebar-and-container/sidebar-and-container.component';
import Title from '../../components/title/title.component';
import '../../global.css';
import AlunoTable from './components/AlunoTable';
import AulasTable from './components/AulasTable';
import BoxDataTurmaDetalhe from './components/BoxDataTurmaDetalhe';
import PorcentagemAulas from './components/PorcentagemAulas';
import './turma-detalhe.css';
import './turma-detalhe.styles.scss';
import useTurmaDetalhe from './useTurmaDetalhe';


export const TurmasDetalhe: React.FunctionComponent = () => {
  const { t } = useTranslation(['gestao_de_aulas', 'common']);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { alunos, aulas, avaliacao } = useTurmaDetalhe();

  const items: TabsProps['items'] = [
  {
    key: '1',
    label: t('gestao_de_aulas:students'),
    children: (
      <AlunoTable
        alunosTableData={alunos.data}
        onPageChange={alunos.onPageChange}
      />
    )
    },
    {
      key: '2',
      label: t('gestao_de_aulas:lessons'),
      children: (
        <AulasTable
          aulasTableData={aulas.data}
          onPageChange={aulas.onPageChange}
          page={aulas.page}
        />
      )
    }
  ];   
//   ...(turmaIsEnglish
//     ? [
//         {
//           key: '3',
//           label: 'Avaliação',
//           children: (
//             <AvaliacoesTable
//               tableData={avaliacao.data}
//               onPageChange={avaliacao.onPageChange}
//               findAvaliacoes={avaliacao.function}
//             />
//           )
//         }
//       ]
//     : [])
// ];

  const availableKeys = items
    .filter(Boolean)
    .map((item) => String(item.key));
  const tabFromUrl = searchParams.get('tab') || '1';
  const activeTabKey = availableKeys.includes(tabFromUrl)
    ? tabFromUrl
    : (availableKeys[0] || '1');

  const handleTabChange = (key: string) => {
    setSearchParams({ tab: key }, { replace: true });
  };

  return (
    <SidebarAndContainer gestaoSalaAula={true}>
      <div className="turma-detalhe__head-buttons">
        <Button
          onClick={() => navigate('/turmas')}
          className="button-second"
          icon={<ArrowLeftOutlined />}
        >
          {t('common:back')}
        </Button>
        <Title title={t('gestao_de_aulas:classDetails')} />
      </div>

      <div className="box-data-turma-detalhe-porcentagem-aulas-wrapper">
        <BoxDataTurmaDetalhe t={t} />
        <PorcentagemAulas t={t} />
      </div>

      <Tabs activeKey={activeTabKey} items={items} onChange={handleTabChange} />
    </SidebarAndContainer>
  );
};
